export default {"src":"/_next/static/media/stack-cards-image.fde530d3.svg","height":500,"width":558};